/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_RevenueInputs */

const en_admin_analyze_allocations_revenue = /** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue`)
};

const de_admin_analyze_allocations_revenue = /** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz`)
};

const es_admin_analyze_allocations_revenue = /** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos`)
};

const fr_admin_analyze_allocations_revenue = /** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenus`)
};

const nl_admin_analyze_allocations_revenue = /** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omzet`)
};

/** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */
const it_admin_analyze_allocations_revenue = en_admin_analyze_allocations_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_revenue = en_admin_analyze_allocations_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */
const pl_admin_analyze_allocations_revenue = en_admin_analyze_allocations_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */
const hu_admin_analyze_allocations_revenue = en_admin_analyze_allocations_revenue;

/** @type {(inputs: Admin_Analyze_Allocations_RevenueInputs) => LocalizedString} */
const ro_admin_analyze_allocations_revenue = en_admin_analyze_allocations_revenue;

/**
* | output |
* | --- |
* | "Revenue" |
*
* @param {Admin_Analyze_Allocations_RevenueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_revenue = /** @type {((inputs?: Admin_Analyze_Allocations_RevenueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_RevenueInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_revenue(inputs)
	if (locale === "de") return de_admin_analyze_allocations_revenue(inputs)
	if (locale === "es") return es_admin_analyze_allocations_revenue(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_revenue(inputs)
	if (locale === "nl") return nl_admin_analyze_allocations_revenue(inputs)
	if (locale === "it") return it_admin_analyze_allocations_revenue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_revenue(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_revenue(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_revenue(inputs)
	return ro_admin_analyze_allocations_revenue(inputs)
});
export { admin_analyze_allocations_revenue as "admin.analyze.allocations.revenue" }